<template>
  <div>
    <div class="p-2   mt-2">
      <div class="flex space-x-2 mb-2 flex-1 items-center">
        <span
          @click="addLoginAddForm = true"
          class="cursor-pointer global-button"
          >Lead'e Platform Ekle</span
        >
      </div>
    </div>

    <div class="border p-4 rounded-lg" v-if="createLoginForm">
      <h4 class="text-sm font-medium ">MÜŞTERİ İÇİN PLATFORM OLUŞTURMA</h4>

      <div class="flex space-x-4">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-20 h-20 text-tile"
          viewBox="0 0 32 32"
        >
          <circle cx="19" cy="27" r="1" fill="currentColor" />
          <path
            fill="currentColor"
            d="M29 31H16c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2h13c1.103 0 2 .897 2 2v4c0 1.103-.897 2-2 2m-13-6v4h13v-4zm13-4H16c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2h13c1.103 0 2 .897 2 2v4c0 1.103-.897 2-2 2m-13-6v4h13v-4z"
          />
          <path
            fill="currentColor"
            d="M12 27.3C7.347 25.648 4 21.213 4 16C4 9.383 9.383 4 16 4c4.831 0 8.994 2.876 10.895 7h2.166C27.042 5.746 21.957 2 16 2C8.28 2 2 8.28 2 16c0 6.33 4.225 11.685 10 13.41z"
          />
        </svg>

        <div>
          <form
            method="post"
            action="javascript:void(0)"
            @submit.prevent="createPlatform()"
          >
            <div class="flex flex-col space-y-2 items-start">
              <div class="flex space-x-2">
                <div>
                  <label>Tür</label>
                  <select v-model="form.type" class="  uk-select">
                    <option value="">Seçiniz</option>
                    <option value="Demo">Demo</option>
                    <option value="Real">Real</option>
                  </select>
                </div>
                <div>
                  <label>Whitelabel</label>
                  <select v-model="form.whitelabel_id" class="uk-select">
                    <option
                      v-for="template in $root.cache.getOptions[154]"
                      :key="template.value"
                      :value="template.value"
                      >{{ template.label }}
                    </option>
                  </select>
                </div>
              </div>

              <savebutton action="createPlatform" title="Oluştur"></savebutton>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="border p-4 rounded-lg" v-if="addLoginAddForm">
      <h4 class="text-sm font-medium ">MÜŞTERİYE PLATFORM ATAMA</h4>

      <div class="flex space-x-4">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-20 h-20 text-tile"
          viewBox="0 0 32 32"
        >
          <circle cx="19" cy="27" r="1" fill="currentColor" />
          <path
            fill="currentColor"
            d="M29 31H16c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2h13c1.103 0 2 .897 2 2v4c0 1.103-.897 2-2 2m-13-6v4h13v-4zm13-4H16c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2h13c1.103 0 2 .897 2 2v4c0 1.103-.897 2-2 2m-13-6v4h13v-4z"
          />
          <path
            fill="currentColor"
            d="M12 27.3C7.347 25.648 4 21.213 4 16C4 9.383 9.383 4 16 4c4.831 0 8.994 2.876 10.895 7h2.166C27.042 5.746 21.957 2 16 2C8.28 2 2 8.28 2 16c0 6.33 4.225 11.685 10 13.41z"
          />
        </svg>

        <div>
          <form
            method="post"
            action="javascript:void(0)"
            @submit.prevent="addPlatform()"
          >
            <div class="flex flex-col space-y-2 items-start">
              <div class="flex space-x-2">
                <div>
                  <label>Login</label>
                  <input type="text" class="uk-input" v-model="form.login" />
                </div>
                <div>
                  <label>Tür</label>
                  <select v-model="form.type" class="  uk-select">
                    <option value="Demo">Demo</option>
                    <option value="Real">Real</option>
                  </select>
                </div>
                <div>
                  <label>Whitelabel</label>
                  <select v-model="form.whitelabel_id" class="  uk-select">
                    <option
                      v-for="template in $root.cache.getOptions[154]"
                      :key="template.value"
                      :value="template.value"
                      >{{ template.label }}
                    </option>
                  </select>
                </div>
              </div>

              <savebutton action="addPlatform" title="Ekle"></savebutton>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div v-if="loading == false">
      <table
        v-if="platforms.length >= 1"
        class="uk-table uk-table-hover    uk-table-middle uk-table-divider"
      >
        <tr>
          <th>Login</th>
          <th>İşlemler</th>
          <th>Tür</th>
          <th>Whitelabel</th>
          <th>Oluşturulma Tarihi</th>
        </tr>
        <tr :key="plt.id" v-for="plt in platforms">
          <td>{{ plt.login }}</td>
          <td>
            <div class="flex space-x-2">
              <AccountDetail
                class="cursor-pointer"
                :login="plt.login"
                :type="plt.type"
              />
              <PlatformDeposit :login="plt.login" :type="plt.type" />
              <PlatformWithdrawal :login="plt.login" :type="plt.type" />
            </div>
          </td>
          <td>
            <span
              v-if="plt.type == 'REAL'"
              class="px-2 py-1 text-xs font-semibold text-green-800 bg-green-100 rounded-full"
              >{{ plt.type }}</span
            >
            <span
              v-else
              class="px-2 py-1 text-xs font-semibold text-red-800 bg-red-100 rounded-full"
              >{{ plt.type }}</span
            >
          </td>
          <td>{{ $root.getVal(154, plt.whitelabel_id) }}</td>
          <td>{{ plt.created_at }}</td>
        </tr>
      </table>

      <div v-else class="flex items-center justify-center flex-col ">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="140"
          height="140"
          class="text-tile-400"
          viewBox="0 0 32 32"
        >
          <circle cx="19" cy="27" r="1" fill="currentColor" />
          <path
            fill="currentColor"
            d="M29 31H16c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2h13c1.103 0 2 .897 2 2v4c0 1.103-.897 2-2 2m-13-6v4h13v-4zm13-4H16c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2h13c1.103 0 2 .897 2 2v4c0 1.103-.897 2-2 2m-13-6v4h13v-4z"
          />
          <path
            fill="currentColor"
            d="M12 27.3C7.347 25.648 4 21.213 4 16C4 9.383 9.383 4 16 4c4.831 0 8.994 2.876 10.895 7h2.166C27.042 5.746 21.957 2 16 2C8.28 2 2 8.28 2 16c0 6.33 4.225 11.685 10 13.41z"
          />
        </svg>

        <span class="text-lg font-semibold text-black"
          >Tanımlı platform bulunamadı</span
        >
        <span class="text-sm font-light text-gray-400"
          >Müşteriye tanımlı olan bir platform varsa ve yetkiniz yoksa
          göremeyebilirsiniz</span
        >
      </div>
    </div>

    <div v-else class="center">
      <vk-spinner ratio="2"></vk-spinner>
    </div>
  </div>
</template>

<script>
import EventBus from "../../../components/Ui/EventBus";
import http from "../../../services/http";
import AccountDetail from "../Ui/AccountDetail";
import PlatformDeposit from "./Platform/PlatformDeposit.vue";
import PlatformWithdrawal from "./Platform/PlatformWithdrawal.vue";
export default {
  name: "MetatraderAccounts",
  components: {
    AccountDetail,
    PlatformDeposit,
    PlatformWithdrawal,
  },
  data() {
    return {
      addLoginAddForm: false,
      createLoginForm: false,
      platforms: [],
      loading: true,
      form: {
        customer_id: this.id,
        type: "Real",
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      http
        .getPlatformData({
          table: "lead_platforms",
          filters: [
            {
              name: "customer_id",
              value: this.id,
              type: 1,
            },
          ],
        })
        .then((e) => {
          this.platforms = e.data.results;
          this.loading = false;
          this.form = {
            customer_id: this.id,
            type: "Real",
          };
        });
    },
    addPlatform() {
      if (this.form.login) {
        this.$parent.$emit("loading", true);
        EventBus.$emit("loadingStatus", {
          action: "addPlatform",
          loading: true,
        });

        http
          .inlineSave({
            table: "lead_platforms",
            type: "insert",
            inputs: this.form,
          })
          .then(() => {
            this.getData();
            EventBus.$emit("loadingStatus", {
              action: "addPlatform",
              loading: false,
              success: true,
            });
          });
      }
    },
    createPlatform() {
      this.form.name = this.lead.name;
      this.form.phone = this.lead.phone;
      this.form.email = this.lead.email;
      this.form.customer_id = this.lead.id;
      this.$parent.$emit("loading", true);
      EventBus.$emit("loadingStatus", {
        action: "createPlatform",
        loading: true,
      });

      http.mt5.createPlatform(this.form).then(() => {
        this.getData();
        EventBus.$emit("loadingStatus", {
          action: "createPlatform",
          loading: false,
          success: true,
        });
      });
    },
  },
  props: ["id", "lead", "modules"],
};
</script>

<style>
.metatrader-accounts-table thead th {
  font-size: 10px;
  color: #222;
}

.metatrader-accounts-table {
  font-size: 12px;
  background: #fff;
  margin-top: 0px;
}
</style>
